import React, { useState, useEffect, useRef } from 'react';
import { Content } from './content';
import { useSelector } from 'react-redux';
import GridViewContent from './gridViewContent';
import GridViewOverlayContent from './gridViewOverlayContent';
import WebinarsContent from './webinarsContent';

export default function ContentTab({ searchResults, isLoadMore, isExpandingSearch, refreshData, isGridView, gridViewName }) {
  const contentRefs = useRef({});
  const searchOptions = useSelector(state => state.search.searchOptions);  
  const [showScore, setShowScore] = useState(false); 
  
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const score = searchParams.get('score') || false;
    setShowScore(score);
  }, []);

  const applyOverlay = () => {
    setTimeout(() => {
      if (gridViewName === 'kits_collections') {
        window.applyImageOverlay();
      }
    }, 100); // Small delay to ensure DOM is ready
  };

  useEffect(() => {
    if (!searchOptions.isPublicSearch){
      const timer = setTimeout(() => {
        const loadMoreTake = 16;
        let _searchOpts = { 
          ...searchOptions,
          skip: parseInt(searchOptions.skip) + parseInt(searchOptions.take),
          take: loadMoreTake,
          total: parseInt(searchOptions.skip) === 0 ? parseInt(searchOptions.take) + loadMoreTake : parseInt(searchOptions.skip) + parseInt(searchOptions.take) + parseInt(searchOptions.take),
          loadMore: true,
          expandingSearch: false
        };
        refreshData(_searchOpts);
      }, 250);

      return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }
  }, []);

  const loadMore = async () => {
    const loadMoreTake = 16;
    let _searchOpts = { 
      ...searchOptions,
      skip: parseInt(searchOptions.skip) + parseInt(searchOptions.take),
      take: loadMoreTake,
      total: parseInt(searchOptions.skip) === 0 ? parseInt(searchOptions.take) + loadMoreTake : parseInt(searchOptions.skip) + parseInt(searchOptions.take) + parseInt(searchOptions.take),
      loadMore: true,
      expandingSearch: false
    };

    refreshData(_searchOpts);

    const currentTotal = searchResults.hits.length - 1;
    setTimeout(() => {
      const firstNewItemRef = contentRefs.current[`content-${currentTotal}`];
      if (firstNewItemRef) {
        firstNewItemRef.focus();
      }
    }, 100);

    applyOverlay();
  }

  const expandSearch = async (total) => {
    let _searchOpts = { 
      ...searchOptions, 
      skip: total,
      total: parseInt(total) + parseInt(searchOptions.take),
      loadMore: false,
      expandingSearch: true,
      expandSearch: true
    };

    refreshData(_searchOpts);
  }

  useEffect(() => {
    // Apply overlay after initial load
    applyOverlay();
  }, [gridViewName, searchResults?.hits]);

  const getCssClassName = (htmlView) => {
    switch (htmlView) {
      case 'infographics':
        return "infographic-wrap grid";
      case 'kits_collections':
        return "kits-collections-wrap grid";
      case 'webinars':
        return "content-group";
      default:
        return "";
    }
  }

  const isOnlyWebinars = searchOptions?.contentType?.length === 1 && searchOptions.contentType[0] === 'webinars';
  return <>
    {/* {isGridView && gridViewName === 'webinars' && searchResults && searchResults.hits && searchResults.hits.length > 0 && (
      <div className="content-group">
        <p class="content-group-title">Upcoming</p>
        {searchResults.hits.filter(x => x.source.contentType === 'webinars' && x.source.webinarStatus === 'upcoming').map((hit, index) => {
          return (
            <WebinarsContent key={hit.id} hit={hit} status="upcoming" contRef={el => contentRefs.current[`content-${index + hit.id}`] = el} />
          );
        })}
      </div>
    )} */}

    <div className={`${isGridView ? getCssClassName(gridViewName) : ''}`}>
      {isGridView && gridViewName === 'webinars' && isOnlyWebinars ? (
        // Show Past Webinars title only if there are past webinars
         searchResults && searchResults.hits && searchResults.hits.length > 0 && (
          <>
            {/* <p class="content-group-title">Past Webinars</p> */}
            {searchResults.hits.filter(x => x.source.contentType === 'webinars')
                                .map((hit, index) => {
              return (
                <WebinarsContent key={hit.id} hit={hit} showScore={showScore} contRef={el => contentRefs.current[`content-${index}`] = el} />
              );
            })}
          </>
        )
      ) : (
        // Show Other Types of Content title only if there are other types of content
        searchResults && searchResults.hits && searchResults.hits.length > 0 && (
          searchResults.hits.map((hit, index) => {
            const htmlView = isGridView ? gridViewName : '';
            switch (htmlView) {
              case 'infographics':
                return (
                  <GridViewContent key={hit.id} hit={hit} showScore={showScore} contRef={el => contentRefs.current[`content-${index}`] = el} />
                );
              case 'kits_collections':
                return (
                  <GridViewOverlayContent key={hit.id} hit={hit} showScore={showScore} contRef={el => contentRefs.current[`content-${index}`] = el} />
                );
              default:
                return (
                  <div
                    className="resultsManagmentCard"
                    key={hit.id}
                    ref={el => contentRefs.current[`content-${index}`] = el}
                    tabIndex="-1"
                  >
                    <Content key={hit.id} hit={hit} showScore={showScore} />
                  </div>
                );
            }
          }
        ))
      )}
      {(!searchResults || !searchResults.hits || searchResults.hits.length === 0) && (
        <div className="">
          <span className="">No results found</span>
        </div>
      )}
    </div>

      {!searchOptions?.isPublicSearch && ((searchResults?.skip + searchResults?.take < searchResults?.total) || (searchResults?.searchExpanded && searchResults?.skip + searchResults?.take < searchResults?.expandedTotal)) && (
        <div className="loadMore">
        <button type="button" onClick={() => loadMore()} variant="secondaryOutlineButton" className="">
          {isLoadMore ? 'Load More...' : 'Load More'}
        </button>
      </div>
      )}
      {searchResults?.skip + searchResults?.take >= searchResults?.total && !searchResults?.searchExpanded && searchResults?.skip + searchResults?.take < searchResults?.expandedTotal && (
        <div className="text-center expand-search">
          <span className="">Can’t find what you’re looking for?</span>
        
          <a onClick={() => {expandSearch(searchResults.total);}}>
            <u>
              {isExpandingSearch ? 'Expanding your search...' : 'Expand Your Search'}
            </u>
          </a>
        </div>
      )}
      {/* {searchOptions?.isPublicSearch && (
        <div>
          <div className="content-detail" style={{maxWidth: '100%'}}>
            <div className="content-detail-body-wrap">
              <div className="membership-box">
                <p className="membership-box-title">Members get access to full search results</p>
                <a className="membership-box-cta" href="/become-a-member/">Membership Options</a>
                <p className="membership-box-text">Already have an account? <a href="/login">Login Now</a></p>
              </div>
            </div>
          </div>
        </div>
      )} */}
  </>
}